import { FloatingLabel } from '@scripts/cf7-form/classes/FloatingLabel.js';
import { FloatingTextarea } from '@scripts/cf7-form/classes/FloatingTextarea.js';
import { CustomSelect } from '@scripts/cf7-form/classes/CustomSelect.js';
import { CharacterCounter } from '@scripts/cf7-form/classes/CharacterCounter.js';

function initForms () {
    const forms = document.querySelectorAll('.wpcf7-form');

    forms.forEach(form => {
        initFloatingLabels(form);
        initCustomSelects(form);
        initCharacterCounters(form);
        initSubmitButton(form);
    });
}

function initFloatingLabels (form) {
    const labels = form.querySelectorAll('label');

    labels.forEach(label => {
        if (!label.classList.contains('no-floating-label') && (label.querySelector('input[type="text"]') || label.querySelector('input[type="email"]'))) {
            label.classList.add('has-floating-label');
            new FloatingLabel(label);
        } else if (label.querySelector('select')) {
            label.classList.add('has-select');
        } else if (label.querySelector('textarea')) {
            label.classList.add('has-textarea');
            new FloatingTextarea(label);
        } else if (label.querySelector('input[type="checkbox"]')) {
            label.classList.add('has-checkbox');
        }
    });
}

function initCustomSelects (form) {
    const selectLabels = form.querySelectorAll('label.has-select');

    selectLabels.forEach(label => {
        new CustomSelect(label);
    });
}

function initCharacterCounters (form) {
    const textareas = form.querySelectorAll('textarea');

    textareas.forEach(textarea => {
        new CharacterCounter(textarea);
    });
}

function initSubmitButton (form) {
    const submitInput = form.querySelector('.wpcf7-submit');

    if (submitInput && submitInput.classList.contains('button')) {
        if (submitInput.tagName === 'INPUT') {
            const text = submitInput.value;

            const button = document.createElement('button');
            button.type = 'submit';
            button.className = submitInput.className;
            button.innerHTML = `<span class="button__text">${text}</span>`;

            if (submitInput.disabled) button.disabled = true;

            submitInput.parentNode.replaceChild(button, submitInput);
        }
    }
}

document.addEventListener('DOMContentLoaded', initForms);

document.addEventListener('wpcf7mailsent', initForms);
document.addEventListener('wpcf7invalid', initForms);
document.addEventListener('wpcf7spam', initForms);
document.addEventListener('wpcf7mailfailed', initForms);

document.addEventListener('wpcf7submit', initForms);
